package dev.danko.roblox_craft_ai.pages.legal.ru

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initRefundsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("legal/ru/refunds.md", FrontMatterElement.Builder { addScalar("title", "Политика возвратов"); addScalar("lang", "ru"); }))
}

@Page("/legal/ru/refunds")
@Layout(".components.layouts.LegalLayout")
@Composable
fun RefundsPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("политика-возвратов") }) {
        org.jetbrains.compose.web.dom.Text("Политика возвратов")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Дата вступления в силу:")
        }
        org.jetbrains.compose.web.dom.Text(" 3 октября 2026 г.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Платежи за Craftiva AI обрабатывает ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Paddle.com")
        }
        org.jetbrains.compose.web.dom.Text(" — наш продавец (Merchant of Record). Paddle оформляет возвраты по этой политике и отвечает на все вопросы об оплате.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Юридически значимой является ")
        com.varabyte.kobweb.silk.components.navigation.Link("/legal/en/refunds") {
            org.jetbrains.compose.web.dom.Text("английская версия")
        }
        org.jetbrains.compose.web.dom.Text("; русская приведена для удобства.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("возврат-в-течение-14-дней") }) {
        org.jetbrains.compose.web.dom.Text("Возврат в течение 14 дней")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Полный возврат можно получить в течение ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("14 дней")
        }
        org.jetbrains.compose.web.dom.Text(" после покупки, если вы потратили ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("не больше 20%")
        }
        org.jetbrains.compose.web.dom.Text(" кредитов из этой покупки:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Подписка")
            }
            org.jetbrains.compose.web.dom.Text(" — не больше 20% месячных кредитов того расчётного периода, за который вы просите возврат. Это касается и первой оплаты, и каждого продления.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Пакет кредитов")
            }
            org.jetbrains.compose.web.dom.Text(" — не больше 20% кредитов пакета.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("После возврата неистраченные кредиты из этой покупки снимаются с аккаунта, а подписка, за которую оформлен возврат, отменяется.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("отмена-подписки") }) {
        org.jetbrains.compose.web.dom.Text("Отмена подписки")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Отменить подписку можно в любой момент на ")
        com.varabyte.kobweb.silk.components.navigation.Link("/pricing") {
            org.jetbrains.compose.web.dom.Text("странице тарифов")
        }
        org.jetbrains.compose.web.dom.Text(" («Управление подпиской») или по ссылке в чеке Paddle. После отмены тариф действует до конца оплаченного периода, новых списаний не будет. Сама по себе отмена не возвращает деньги за текущий период — для этого воспользуйтесь возвратом в течение 14 дней, если он применим.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("неудачные-генерации") }) {
        org.jetbrains.compose.web.dom.Text("Неудачные генерации")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Если генерация не удалась из-за ошибки на нашей стороне, её кредиты автоматически возвращаются на баланс. Запрашивать это не нужно.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("исключения") }) {
        org.jetbrains.compose.web.dom.Text("Исключения")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Мы можем отказать в возврате при злоупотреблениях — например, при повторяющихся покупках и возвратах или если большая часть кредитов потрачена до запроса. Возврат не предоставляется по аккаунтам, закрытым за нарушение ")
        com.varabyte.kobweb.silk.components.navigation.Link("/legal/ru/terms") {
            org.jetbrains.compose.web.dom.Text("Условий использования")
        }
        org.jetbrains.compose.web.dom.Text(". Это не ограничивает ваши права по закону о защите прав потребителей страны проживания.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("как-запросить-возврат") }) {
        org.jetbrains.compose.web.dom.Text("Как запросить возврат")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Напишите на [SUPPORT_EMAIL] с email вашего аккаунта и укажите номер заказа из чека Paddle — или обратитесь напрямую в Paddle на ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://paddle.net") {
            org.jetbrains.compose.web.dom.Text("paddle.net")
        }
        org.jetbrains.compose.web.dom.Text(". Деньги возвращаются тем же способом оплаты, обычно за 5–10 рабочих дней, в зависимости от банка.")
    }
}
